import { UserAccount } from "@data-types";
import { UserAuthStore } from "@state/shared";
import { THEME_SETTINGS } from "@theme-settings";
import { BETTING_TYPE_ACCOUNTS_ABRV } from "@utils/bet-slip/bettingTypeAccountAbrvs";

// This will find valid wallets by user and find one which is currentlyActive and return it
export function findValidSubmitWallet(
	store: UserAuthStore
): UserAccount | null {
	const wallet =
		store.userAccounts?.find(
			(wallet) => wallet.id == store.activeWalletId
		) || null;

	if (THEME_SETTINGS.isDKMW) {
		const activeUserId = wallet?.userId;

		if (!activeUserId) {
			return wallet;
		}

		const wallets = store.walletsByUserId[activeUserId];
		if (!wallets?.length) {
			return wallet;
		}

		const validWallets = wallets.filter((wallet) =>
			BETTING_TYPE_ACCOUNTS_ABRV.includes(wallet.abrv)
		);

		return (
			validWallets.find((wallet) => wallet.isCurrentlyActive) || wallet
		);
	}

	return wallet;
}
